module.exports = __webpack_public_path__ + "static/media/logo_aquiFomento.ea087b4e.jpeg";